var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.result && _vm.result.totalGlobal),expression:"!!result && result.totalGlobal"}],staticClass:"task-result"},[_c('span',{staticClass:"result"},[_vm._v("\n    "+_vm._s(_vm.result && _vm.result.totalGlobal)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fc80057","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/board/components/task-result/TaskResult.vue
// module id = null
// module chunks = 